import { Platform } from '../../constants';

export default Platform.web;
